import { SharedModule } from 'app/shared/shared.module';
import { AddOrganizationComponent } from './../../shared/common/add-organization/add-organization.component';
import { NgModule } from '@angular/core';
import { ProfileModule } from './profile/profile.module';
import { EmployeesModule } from './employees/employees.module';
import { TimesheetModule } from './timesheet/timesheet.module';
import { ClientsModule } from './clients/clients.module';
import { ProjectsModule } from './projects/projects.module';
import { ClientCreateModule } from './clients/client-create/client-create.module';
import { ResetPasswordModule } from './authentication/reset-password/reset-password.module';
import { ProjectCreateModule } from './projects/project-create/project-create.module';
import { ProjectListModule } from './projects/project-list/project-list.module';
import { TimesheetViewModule } from './timesheet-view/timesheet-view.module';
import { ProfileViewModule } from './profile-view/profile-view.module';
import { ViolationsModule } from './violations/violations.module';
import { TeamViolationModule } from './violations/team-violation/team-violation.module';
import { AttendanceModule } from './attendance/attendance.module';
import { CalendarModule } from './calendar/calendar.module';
import { ProjectDashboardModule } from './dashboards/project/project.module';
import { AnalyticsDashboardModule } from './dashboards/analytics/analytics.module';
import { ScrumboardModule } from './scrumboard/scrumboard.module';
import { EmployeesDashboardModule } from './dashboards/employees-dashboard/employees-dashboard.module';
import { JobsModule } from './jobs/jobs.module';
import { ActivityModule } from './activity-center/activity-center.module';
import { MatTabsModule, MatDatepickerModule, MatSelectModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatOptionModule, MatIconModule, MatCheckboxModule, MatExpansionModule, MatTableModule, MatDialogModule, MatCardModule, MatPaginatorModule, MatMenuModule, MatDividerModule, MatAutocompleteModule, MatButtonToggleModule, MatListModule, MatSlideToggleModule } from '@angular/material';
import { GitlabReportModule } from './gitlab-report/gitlab-report.module';
import { OpportunityListModule } from './opportunity/opportunity-list/opportunity-list.module';
import { ProjectEnquiryModule } from './opportunity/project-enquiry/project-enquiry.module';
import { TimesheetRankDashboardModule } from './dashboards/timesheet-rank/timesheet-rank.module';
import { ProjectMetricsModule } from './dashboards/project-metrics/project-metrics.module';
import { WorkStatusModule } from './dashboards/work-status/work-status.module';
import { MyTeamModule } from './my-team/my-team.module';
import { OnGoingProjectListModule } from './projects/onGoing-project-list/on-going-project-list.module';
import { OnHoldProjectListModule } from './projects/onHold-project-list/on-hold-project-list.module';
import { EmployeesTasksModule } from 'app/main/pages/dashboards/employees-tasks/employees-tasks.module';
import { PageVisitModule } from './dashboards/page-visit/page-visit.module';
import { TodoListItemModule } from './todo-list/todo-list-item/todo-list-item.module';
import { PerformanceOverViewModule } from './performance-overview/performance-overview.module';
import { DemoVideosModule } from './demo-videos/demo-videos/demo-videos.module';
import { AdminAddonsListModule } from './projects/admin-addons-list/admin-addons-list.module';
import { OnboardingModule } from './onboarding/onboarding.module';
import { DefaultTaskModule } from './settings/default-task/default-task.module';
import { SettingModule } from './settings/setting.module';
import { PlanModule } from './plan/plan.module';

import { PlanSubscribeComponent } from './plan-subscribe/plan-subscribe.component';
import { RouterModule, Routes } from '@angular/router';
import { DesktopAppsDownloadModule } from './desktop-apps-download/desktop-apps-download.module';
import { MetricsModule } from './metrics/metrics.module';
import { CheckInOutReportModule } from './dashboards/check-in-out-report/check-in-out-report.module';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/primeng';
// import { TimesheetViewComponent } from './timesheet-view/timesheet-view.component';
import { MaterialModule } from 'app/shared/material.module';


const routes: Routes = [
  { path: 'plan-subscribe', component: PlanSubscribeComponent },
  {
    path: 'activity-center',
    loadChildren: './activity-center/activity-center.module#ActivityModule'
  },
  {
    path: 'attendance',
    loadChildren: './attendance/attendance.module#AttendanceModule'
  },
  {
    path: 'reset-password',
    loadChildren: './authentication/reset-password/reset-password.module#ResetPasswordModule'
  },
  {
    path: 'calendar',
    loadChildren: './calendar/calendar.module#CalendarModule'
  },
  {
    path: 'clients',
    loadChildren: './clients/clients.module#ClientsModule'
  },
  {
    path: 'client-create',
    loadChildren: './clients/client-create/client-create.module#ClientCreateModule'
  },
  {
    path: 'work-status',
    loadChildren: './dashboards/work-status/work-status.module#WorkStatusModule'
  },
  {
    path: 'timesheet-dashboard',
    loadChildren: './dashboards/timesheet-rank/timesheet-rank.module#TimesheetRankDashboardModule'
  },
  {
    path: 'project-metrics',
    loadChildren: './dashboards/project-metrics/project-metrics.module#ProjectMetricsModule'
  },
  {
    path: 'projectdashboard',
    loadChildren: './dashboards/project/project.module#ProjectDashboardModule'
  },
  {
    path: 'page-visit',
    loadChildren: './dashboards/page-visit/page-visit.module#PageVisitModule'
  },
  {
    path: 'employees-tasks',
    loadChildren: 'app/main/pages/dashboards/employees-tasks/employees-tasks.module#EmployeesTasksModule'
  },
  {
    path: 'employees-dashboard',
    loadChildren: './dashboards/employees-dashboard/employees-dashboard.module#EmployeesDashboardModule'
  },
  {
    path: 'CheckInOut',
    loadChildren: './dashboards/check-in-out-report/check-in-out-report.module#CheckInOutReportModule'
  },
  {
    path: 'analytics-dashboard',
    loadChildren: './dashboards/analytics/analytics.module#AnalyticsDashboardModule'
  },
  {
    path: 'demo-videos',
    loadChildren: './demo-videos/demo-videos/demo-videos.module#DemoVideosModule'
  },
  {
    path: 'desktop-apps-download',
    loadChildren: './desktop-apps-download/desktop-apps-download.module#DesktopAppsDownloadModule'
  },
  {
    path: 'employees-details',
    loadChildren: './employees/employees.module#EmployeesModule'
  },
  {
    path: 'projects-commit',
    loadChildren: './gitlab-report/gitlab-report.module#GitlabReportModule'
  },
  {
    path: 'jobs',
    loadChildren: './jobs/jobs.module#JobsModule'
  },
  {
    path: 'metrics',
    loadChildren: './metrics/metrics.module#MetricsModule'
  },
  {
    path: 'my-team',
    loadChildren: './my-team/my-team.module#MyTeamModule'
  },
  // {
  //   path: 'project-enquiry',
  //   loadChildren: './opportunity/project-enquiry/project-enquiry.module#ProjectEnquiryModule'
  // },
  // {
  //   path: 'opportunity-list',
  //   loadChildren: './opportunity/opportunity-list/opportunity-list.module#OpportunityListModule'
  // },
  {
    path: 'performance-review',
    loadChildren: './performance-overview/performance-overview.module#PerformanceOverViewModule'
  },
  {
    path: 'plans',
    loadChildren: './plan/plan.module#PlanModule'
  },
  {
    path: 'profile',
    loadChildren: './profile/profile.module#ProfileModule'
  },
  {
    path: 'profile-view',
    loadChildren: './profile-view/profile-view.module#ProfileViewModule'
  },
  {
    path: 'projects',
    loadChildren: './projects/projects.module#ProjectsModule'
  },
  {
    path: 'admin-addons-list',
    loadChildren: './projects/admin-addons-list/admin-addons-list.module#AdminAddonsListModule'
  },
  {
    path: 'on-going-project-list',
    loadChildren: './projects/onGoing-project-list/on-going-project-list.module#OnGoingProjectListModule'
  },
  {
    path: 'on-hold-project-list',
    loadChildren: './projects/onHold-project-list/on-hold-project-list.module#OnHoldProjectListModule'
  },
  {
    path: 'project-create',
    loadChildren: './projects/project-create/project-create.module#ProjectCreateModule'
  },
  {
    path: 'project-list',
    loadChildren: './projects/project-list/project-list.module#ProjectListModule'
  },
  {
    path: 'scrumboard/boards/:boardId/:boardUri',
    loadChildren: './scrumboard/scrumboard.module#ScrumboardModule'
  },
  {
    path: 'settings',
    loadChildren: './settings/setting.module#SettingModule'
  },
  {
    path: 'onboarding',
    loadChildren: './onboarding/onboarding.module#OnboardingModule'
  },
  {
    path: 'user-timesheet',
    loadChildren: './timesheet/timesheet.module#TimesheetModule'
  },
  {
    path: 'timesheet-view',
    loadChildren: './timesheet-view/timesheet-view.module#TimesheetViewModule'
  },
  {
    path: 'todo-list-item',
    loadChildren: './todo-list/todo-list-item/todo-list-item.module#TodoListItemModule'
  },
  {
    path: 'violations',
    loadChildren: './violations/violations.module#ViolationsModule'
  },
  {
    path: 'team-violation',
    loadChildren: './violations/team-violation/team-violation.module#TeamViolationModule'
  },

];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    ProfileModule,
    EmployeesModule,
    TimesheetModule,
    ClientsModule,
    ProjectsModule,
    ResetPasswordModule,
    ProjectCreateModule,
    ClientCreateModule,
    ProjectListModule,
    TimesheetViewModule,
    ProfileViewModule,
    ViolationsModule,
    TeamViolationModule,
    AttendanceModule,
    CalendarModule,
    ProjectDashboardModule,
    AnalyticsDashboardModule,
    ScrumboardModule,
    EmployeesDashboardModule,
    // ProjectDashboardModule,
    JobsModule,
    ActivityModule,
    MatTabsModule,
    MatDatepickerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    GitlabReportModule,
    OpportunityListModule,
    ProjectEnquiryModule,
    TimesheetRankDashboardModule,
    ProjectMetricsModule,
    WorkStatusModule,
    MyTeamModule,
    OnHoldProjectListModule,
    OnGoingProjectListModule,
    EmployeesTasksModule,
    PageVisitModule,
    TodoListItemModule,
    PerformanceOverViewModule,
    DemoVideosModule,
    AdminAddonsListModule,
    OnboardingModule,
    DefaultTaskModule,
    SettingModule,
    PlanModule,
    DesktopAppsDownloadModule,
    MetricsModule,
    SharedModule,
    MaterialModule,
    CheckInOutReportModule
    // MatButtonModule,
    // MatIconModule,
    // MatMomentDateModule,
    // MatInputModule,
    // MatCheckboxModule,
    // MatTabsModule,
    // MatSelectModule,
    // MatDatepickerModule,
    // MatExpansionModule,
    // MatTableModule,
    // MatDialogModule,
    // MatCardModule,
    // MatOptionModule,
    // MatPaginatorModule,
    // MatMenuModule,
    // MatButtonModule,
    // MatDividerModule,
    // MatFormFieldModule,
    // MatIconModule,
    // MatMenuModule,
    // MatSelectModule,
    // MatAutocompleteModule,
    // MatButtonToggleModule,
    // MatListModule,
    // MatSlideToggleModule,
    // RoundProgressModule,
    // TableModule,
    // PaginatorModule,
    
  ],
  declarations: [PlanSubscribeComponent,
    ]
})

export class PagesModule { }
